// src/pages/LoginComLink.js
//
// Conclui o login por link mágico (Firebase Auth Email Link sign-in),
// usado pelo perfil ALTA GESTAO no módulo Priorização Colegiada.

import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../hooks/useToast';
import Spinner from '../components/common/Spinner/Spinner';
import BackButton from '../components/common/BackButton/BackButton';
import {
  isLinkMagicoAtual,
  emailSalvoParaLinkMagico,
  concluirLoginComLinkMagico,
} from '../services/magicLinkAuth';
import './RecuperarSenha.css';

const logo = '/logo_gif.gif';

const LoginComLink = () => {
  const [status, setStatus] = useState('verificando'); // verificando | precisaEmail | entrando | invalido
  const [email, setEmail] = useState('');
  const [erro, setErro] = useState('');
  const navigate = useNavigate();
  const { addToast } = useToast();

  const tentarLogin = useCallback(async (emailParaLogin) => {
    setStatus('entrando');
    setErro('');
    try {
      await concluirLoginComLinkMagico(emailParaLogin);
      addToast('Acesso confirmado!', 'success');
      navigate('/dashboard', { replace: true });
    } catch (error) {
      console.error('[LoginComLink] Falha ao concluir login', error);
      setStatus('precisaEmail');
      setErro('Não foi possível concluir o acesso. Confira o e-mail e tente novamente, ou peça um novo convite.');
    }
  }, [addToast, navigate]);

  useEffect(() => {
    if (!isLinkMagicoAtual()) {
      setStatus('invalido');
      return;
    }
    const emailSalvo = emailSalvoParaLinkMagico();
    if (emailSalvo) {
      tentarLogin(emailSalvo);
    } else {
      setStatus('precisaEmail');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) tentarLogin(email);
  };

  return (
    <div className="hero-section">
      <div className="hero-column-left">
        <div className="storytelling">
          <img src={logo} alt="Logo Mago" className="login-logo-main" />
          <h1 className="headline">Acesso por link. <span>Sem senha.</span></h1>
          <p className="support-text">
            Você foi convidado para participar da Priorização Colegiada da sua organização.
          </p>
        </div>
      </div>
      <div className="hero-column-right">
        <div className="login-form-panel">
          {status === 'verificando' || status === 'entrando' ? (
            <>
              <h2>Confirmando seu acesso...</h2>
              <Spinner text="Só um instante." />
            </>
          ) : status === 'invalido' ? (
            <>
              <h2>Link inválido ou expirado</h2>
              <p className="form-subtitle">
                Este link de acesso não é mais válido. Peça ao administrador da sua organização
                para reenviar o convite.
              </p>
              <BackButton label="Ir para o Login" onClick={() => navigate('/login')} style={{ marginTop: '1rem' }} />
            </>
          ) : (
            <>
              <h2>Confirme seu e-mail</h2>
              <p className="form-subtitle">
                Para concluir o acesso, digite o e-mail para o qual o convite foi enviado.
              </p>
              {erro && <p className="form-error" role="alert">{erro}</p>}
              <form onSubmit={handleSubmit} className="login-form">
                <div className="input-group">
                  <label htmlFor="email">E-mail</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="seu.email@exemplo.com"
                    required
                    autoComplete="email"
                  />
                </div>
                <button type="submit" className="login-button">
                  Confirmar e entrar
                </button>
              </form>
              <BackButton label="Voltar para o Login" onClick={() => navigate('/login')} style={{ marginTop: '1rem' }} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginComLink;
